import { Box, Button, TextField, styled } from '@mui/material';

// Theme colors
export const themeColors = {
  turq: '#00B6BA', // Theme Primary Turquoise
  white: '#FFFFFF',
  light: '#F8F8F8',
  border: '#E7EFF5',
  navy: '#063142',
};

// Styled components for segmented controls
export const SegmentedControlContainer = styled(Box)(() => ({
  display: 'flex',
  borderRadius: '4px',
  overflow: 'hidden',
  height: '36px',
  width: '100%',
  border: 'none',
}));

export const SegmentButton = styled(Box)<{ active: boolean }>(({ active }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '0 16px',
  height: '100%',
  flexShrink: 0,
  cursor: 'pointer',
  backgroundColor: active ? themeColors.turq : themeColors.white,
  color: active ? themeColors.white : themeColors.turq,
  fontFamily: '"Lato-Regular", sans-serif',
  fontSize: '14px',
  transition: 'background-color 0.2s, color 0.2s',
  borderTop: `1px solid ${themeColors.turq}`,
  borderBottom: `1px solid ${themeColors.turq}`,
  borderRight: `1px solid ${themeColors.turq}`,
  '&:first-of-type': {
    borderLeft: `1px solid ${themeColors.turq}`,
    borderTopLeftRadius: '4px',
    borderBottomLeftRadius: '4px',
  },
  '&:last-of-type': {
    borderTopRightRadius: '4px',
    borderBottomRightRadius: '4px',
  },
  '&:hover': {
    backgroundColor: active ? themeColors.turq : 'rgba(0, 182, 186, 0.1)',
  },
}));

export const PPOButton = styled(Button)(() => ({
  borderRadius: '4px',
  textTransform: 'none',
  minWidth: '100px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '8px 12px',
  backgroundColor: themeColors.light,
  border: `1px solid ${themeColors.border}`,
  color: themeColors.navy,
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: themeColors.light,
    boxShadow: 'none',
  },
}));

export const SearchField = styled(TextField)(() => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: '4px',
    color: themeColors.navy,
    '& fieldset': {
      borderColor: themeColors.navy,
      borderRadius: '4px',
    },
    '&:hover fieldset': {
      borderColor: themeColors.border,
    },
    '&.Mui-focused fieldset': {
      borderColor: themeColors.turq,
    },
  },
  '& .MuiInputBase-input': {
    padding: '8px 12px',
    fontSize: '14px',
  },
})); 